export const en = {
    campaign_broad_match_goal_all: 'Optimizing conversion rate for all goals',
    campaign_broad_match_goal_changed: 'Optimize conversion {oldGoal} {newGoal}',
    campaign_broad_match_goal_id: 'Optimizing conversion rate for goal "{goalName}"',
    campaign_broad_match_limit: 'Spend up to {limit}% of the total campaign expenditure',
    campaign_broad_match_limit_changed: 'Spend up to {oldLimit} {newLimit} of the total campaign expenditure',
    'on-all-goals': 'all goals',
    'on-goal': 'for goal "{goalName}"'
};
